import * as yup from 'yup';

const requiredMessage = field => `${field} is required`;
const minMessage = min => `Must have at least ${min} characters`;
const maxMessage = max => `Cannot have more than ${max} characters`;
const invalidMessage = field => `Invalid ${field}`;

export const mainSchema = yup.object().shape({
  name: yup
    .string()
    .min(4, minMessage(4))
    .max(255, maxMessage(255))
    .required(requiredMessage('Company name')),
  ceo: yup
    .string()
    .min(2, minMessage(2))
    .max(255, maxMessage(255))
    .required(requiredMessage('CEO')),
  about: yup
    .string()
    .min(10, minMessage(10))
    .max(4000, maxMessage(4000))
    .required(requiredMessage('About')),
  phone: yup
    .number()
    .typeError('Phone number must be a number')
    .test(
      'len',
      'Phone number must be exactly 10 digits',
      val => val && val.toString().length === 10
    ),
  email: yup.string().email(invalidMessage('email')),
  webSite: yup.string().url(invalidMessage('website'))
});
